'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var _require = require('../utils/cid'),
    cidToString = _require.cidToString;

var log = debug('ipfs:mfs-preload');
log.error = debug('ipfs:mfs-preload:error');

module.exports = function (_ref) {
  var preload = _ref.preload,
      files = _ref.files,
      options = _ref.options;
  options = options || {};
  options.interval = options.interval || 30 * 1000;

  if (!options.enabled) {
    log('MFS preload disabled');

    var noop = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function noop() {
        return _ref2.apply(this, arguments);
      };
    }();

    return {
      start: noop,
      stop: noop
    };
  }

  var rootCid, timeoutId;

  var preloadMfs = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var stats, nextRootCid;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return files.stat('/');

            case 3:
              stats = _context2.sent;
              nextRootCid = cidToString(stats.cid, {
                base: 'base32'
              });

              if (!(rootCid !== nextRootCid)) {
                _context2.next = 10;
                break;
              }

              log("preloading updated MFS root ".concat(rootCid, " -> ").concat(stats.cid));
              _context2.next = 9;
              return preload(stats.cid);

            case 9:
              rootCid = nextRootCid;

            case 10:
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              log.error('failed to preload MFS root', _context2.t0);

            case 15:
              _context2.prev = 15;
              timeoutId = setTimeout(preloadMfs, options.interval);
              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12, 15, 18]]);
    }));

    return function preloadMfs() {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    start: function start() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var stats;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return files.stat('/');

              case 2:
                stats = _context3.sent;
                rootCid = cidToString(stats.cid, {
                  base: 'base32'
                });
                log("monitoring MFS root ".concat(stats.cid));
                timeoutId = setTimeout(preloadMfs, options.interval);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    stop: function stop() {
      clearTimeout(timeoutId);
    }
  };
};